import * as React from "react";
import { SVGProps } from "react";
const SvgThermometer = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 25c0 3.9 3.1 7 7 7s7-3.1 7-7c0-1.8-.7-3.6-2-4.9V5c0-2.8-2.2-5-5-5s-5 2.2-5 5v15.1c-1.3 1.3-2 3.1-2 4.9Zm4-20c0-1.7 1.3-3 3-3s3 1.3 3 3v16l.3.3c1.1.9 1.7 2.3 1.7 3.7 0 2.8-2.2 5-5 5s-5-2.2-5-5c0-1.4.6-2.8 1.7-3.7l.3-.3V5Zm4 6v11.2c1.2.4 2 1.5 2 2.8 0 1.7-1.3 3-3 3s-3-1.3-3-3c0-1.3.8-2.4 2-2.8V11h2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgThermometer;
